import { NgModule } from '@angular/core';
import { OwnerApplicationService } from 'ng2-app/modules/owner-application/models/owner-application.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        OwnerApplicationService
    ],
})
export class OwnerApplicationModule { }
